import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";

// Member Login API
export const memberLoginApi = createAsyncThunk(
  "AuthSlice/memberLoginApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const fullUrl = baseUrl + "member/login";
      
      const { data: response } = await axios.post(
        fullUrl,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.success) {
        // Store token in localStorage
        if (response.token) {
          localStorage.setItem("memberToken", response.token);
        }
        
        // Store member data in localStorage for persistence
        if (response.member) {
          localStorage.setItem("memberData", JSON.stringify(response.member));
        }
        
        // Store credentials for external login (encrypted would be better in production)
        if (credentials.email && credentials.password) {
          localStorage.setItem("memberCredentials", JSON.stringify({
            email: credentials.email,
            password: credentials.password
          }));
        }
        
        return { 
          member: response.member, 
          token: response.token,
          message: response.message 
        };
      } else {
        return rejectWithValue(response.message || "Login failed");
      }
    } catch (error) {
      console.error("Member Login API Error", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "Login failed"
      );
    }
  }
);

// Legacy functions (keeping for backward compatibility)
export const loginUser = async (credentials) => {
  const response = await axios.post(baseUrl + 'auth/login', credentials);
  return response.data;
};

export const registerUser = async (userData) => {
  const response = await axios.post(baseUrl + 'auth/register', userData);
  return response.data;
};

export const logoutUser = async () => {
  const response = await axios.post(baseUrl + 'auth/logout');
  return response.data;
};
